module.exports = __webpack_public_path__ + "img/question15c4.841c458d.png";